// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper-NqHQ1C","description":"description-J1CY5j","clamped":"clamped-KbJJ1s","actions":"actions-rpFpRu","moreButton":"moreButton-ySxDP4"};